import { Box, TextField, Typography } from "@mui/material";

// Converts dd-MM-yyyy (stored) → yyyy-MM-dd (for HTML date input display)
const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
};

// Converts yyyy-MM-dd (from HTML date input) → dd-MM-yyyy (for storage / backend)
const formatDateForStorage = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
};


const BondAgreementLetterForm = ({ data, setData }) => {

    const handleChange = (key, value) => {
        if (key === "bond_agreement_date") {
            value = formatDateForStorage(value);
        }

        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Box sx={{ mt: 1 }}>



            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    gap: 2
                }}
            >
                <Box>
                    <TextField
                        type="date"
                        label="Bond Agreement Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.bond_agreement_date ? formatDateForInput(data.bond_agreement_date) : ""}
                        onChange={(e) => handleChange("bond_agreement_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="number"
                        label="Number Of Months"
                        fullWidth
                        value={data.number_of_months || ""}
                        onChange={(e) => handleChange("number_of_months", e.target.value)}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default BondAgreementLetterForm;
